import { Wind, PawPrint, Zap } from "lucide-react";

// Config-driven "meter" micro-quizzes. Each slides a value 0-100, maps it to a
// breed trait bucket (1-5), and reveals a shareable, screenshot-ready card.
// Add a new quiz by appending a config object here.

export const FUR_METER = {
  slug: "fur-meter",
  gaPrefix: "fur_meter",
  metaTitle: "The Tuesday Fur-Meter — Which dog matches your fur tolerance? | Fetchright",
  metaDesc: "Slide from 'Zero Fur' to 'Living Rug' and get your matched dog breed in one tap. A playful mini-quiz from Fetchright.",
  brandBadge: "Tuesday Fur-Meter",
  cardBadge: "Fur-Meter",
  BadgeIcon: Wind,
  MeterIcon: PawPrint,
  headline: ["How much fur can you", "actually live with?"],
  sub: "Drag the meter, hit reveal, and meet the dog that matches your fur tolerance. It's a Tuesday thing.",
  leftLabel: "🚫 Zero Fur",
  rightLabel: "Living Rug 🧶",
  ctaLabel: "Reveal my dog match",
  matchLabel: "Your Tuesday dog match",
  unitLabel: "Shed",
  traitField: "shedding",
  zones: [
    { max: 20, level: 1, label: "Zero Fur", persona: "The Lint-Roller Minimalist", summary: "You'd sooner adopt a houseplant than vacuum twice a day. Your soulmate sheds about as much as a pet rock — and you love it that way." },
    { max: 40, level: 2, label: "Barely There", persona: "The Tidy Optimist", summary: "A little fuzz won't ruin your day, but you still gasp when a tumbleweed of fur rolls across the floorboards. Low-key and low-shed is your vibe." },
    { max: 60, level: 3, label: "Casual Shedder", persona: "The Fur Realist", summary: "Dog hair on your black jeans? A small tax you happily pay for unconditional love. You've made peace with the lint roller in your car." },
    { max: 80, level: 4, label: "Fur Everywhere", persona: "The Fur Whisperer", summary: "You've accepted that fur is now both a food group and a fashion accessory. Your vacuum works overtime and you wouldn't change a thing." },
    { max: 101, level: 5, label: "Living Rug", persona: "The Fur Maximalist", summary: "Your couch has grown a second coat, your coffee comes with 'extra protein', and honestly? You're living your best fluffy life." },
  ],
};

export const CHAOS_METER = {
  slug: "chaos-meter",
  gaPrefix: "chaos_meter",
  metaTitle: "The Dog Chaos Meter — How much energy can you handle? | Fetchright",
  metaDesc: "Slide from 'Total Zen' to 'Absolute Chaos' and meet the dog that matches your energy. A playful mini-quiz from Fetchright.",
  brandBadge: "Dog Chaos Meter",
  cardBadge: "Chaos Meter",
  BadgeIcon: Zap,
  MeterIcon: Zap,
  headline: ["How much dog chaos", "can you actually handle?"],
  sub: "Drag the meter, hit reveal, and meet the dog that matches your energy. Zoomies not included.",
  leftLabel: "😴 Total Zen",
  rightLabel: "Absolute Chaos ⚡",
  ctaLabel: "Reveal my chaos match",
  matchLabel: "Your energy match",
  unitLabel: "Energy",
  traitField: "energy",
  zones: [
    { max: 20, level: 2, label: "Total Zen", persona: "The Couch Philosopher", summary: "Your ideal Saturday is a nap, a book, and a dog who wholeheartedly agrees. Zoomies? Never heard of her." },
    { max: 40, level: 3, label: "Gently Bouncy", persona: "The Balanced Buddy", summary: "A walk, a cuddle, repeat. You want a dog with an 'off' switch — and the good sense to actually use it." },
    { max: 60, level: 4, label: "Weekend Warrior", persona: "The Adventure Mate", summary: "Hikes, fetch, the occasional gremlin moment — you can keep up. Most of the time. Probably." },
    { max: 80, level: 5, label: "High Octane", persona: "The Energiser", summary: "If it's not tired by 9pm, neither are you. You need a dog that treats every single day like the Olympics." },
    { max: 101, level: 5, label: "Absolute Chaos", persona: "The Chaos Coordinator", summary: "You don't want a pet, you want a co-conspirator. Bring on the zoomies, the mud, and the beautiful madness." },
  ],
};

export const METER_QUIZZES = {
  [FUR_METER.slug]: FUR_METER,
  [CHAOS_METER.slug]: CHAOS_METER,
};
